var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from 'common';
export default function ProtectedRoute(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const isAuthenticated = useSelector(selectIsAuthenticated());
    return (React.createElement(Route, Object.assign({}, rest, { render: function render({ location }) {
            return isAuthenticated
                ? (children)
                : (React.createElement(Redirect, { to: {
                        pathname: "/authentification",
                        state: { from: location }
                    } }));
        } })));
}
